import axios from "./axios";
const ServiciosGeneral = {
  llamarServidor: (ruta) => (setCtl, setCargando, body) => {
    setCargando(true);
    axios
      .get(ruta, body)
      .then((response) => {
        setCtl(response.data);
        setCargando(false);
      })
      .catch((error) => {
        if (error.response && error.response.status == 403) {
          alert("Sesión caducada");
          localStorage.clear();
          window.location.reload(true);
        } else {
          setCtl([]);
          // console.log(error);
          setCargando(false);
        }
      });
  },
  llamarServidorRespuesta: (ruta) => (respuesta, setCargando, body) => {
    setCargando(true);
    axios
      .post(ruta, body)
      .then((response) => {
        if (response.status === 200 && response.data.status != undefined)
          respuesta(
            response.data.status,
            response.data.mensaje,
            response.data.data
          );
        else respuesta(-5, "ERROR DESCONOCIDO");

        setCargando(false);
      })
      .catch((error) => {
        if (error.response)
          if (error.response?.status == 403) {
            alert("Sesión caducada");
            localStorage.clear();
            window.location.reload(true);
          } else {
            respuesta(-1, "Error de servidor");
            setCargando(false);
          }
      });
  },
  llamarServidorRespuestaFile: (ruta) => (respuesta, setCargando, body) => {
    setCargando(true);
    axios
      .post(ruta, body,{headers:{
        'Content-Type': 'multipart/form-data'
      }})
      .then((response) => {
        setCargando(false);

        if (response.status === 200 && response.data.status != undefined)
          respuesta(
            response.data.status,
            response.data.mensaje,
            response.data.data
          );
        else respuesta(-5, "ERROR DESCONOCIDO");
      })
      .catch((error) => {
        if (error.response)
          if (error.response?.status == 403) {
            alert("Sesión caducada");
            localStorage.clear();
            window.location.reload(true);
          } else {
            respuesta(-1, "Error de servidor");
            setCargando(false);
          }
      });
  },
  llamarServidorRespuestaPost: (ruta) => (setCtl, setCargando, body) => {
    setCargando(true);
    axios
      .post(ruta, body)
      .then((response) => {
        setCtl(response.data);
        setCargando(false);
      })
      .catch((error) => {
        if (error.response && error.response.status == 403) {
          alert("Sesión caducada");
          localStorage.clear();
          window.location.reload(true);
        } else {
          setCtl([]);
          // console.log(error);
          setCargando(false);
        }
      });
  },

  // llamarServidorRespuestaGet: (ruta) => (setCtl, setCargando, body) => {
  //   setCargando(true);
  //   axios
  //     .get(ruta, { responseType: "blob" })
  //     .then((response) => {
  //       FileDownload(response.data, filename);
  //     })
  //     .catch((error) => {
  //       if (error.response && error.response.status == 403) {
  //         alert("Sesión caducada");
  //         localStorage.clear();
  //         window.location.reload(true);
  //       } else {
  //         setCtl([]);
  //         console.log(error);
  //         setCargando(false);
  //       }
  //     });
  // },
};

export default ServiciosGeneral;
